export default "__VITE_ASSET__28eb435f__"